import React from 'react';

import { COLOR_BLACK } from 'client/components/MarketingPagesShared/styles';

export function CreateIcon({ color = COLOR_BLACK }: { color?: string }) {
  return (
    <svg viewBox="0 0 106 125" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.9916 71.3315C44.2668 71.3315 28.7353 83.9059 21.599 102.466C19.5479 107.8 20.9099 112.823 24.2924 116.605C27.7169 120.434 33.2157 122.962 39.2334 122.962H84.7497C90.7674 122.962 96.2662 120.434 99.6907 116.605C103.073 112.823 104.435 107.8 102.384 102.466C95.2479 83.9059 79.7163 71.3315 61.9916 71.3315ZM19.6967 101.734C27.0591 82.5864 43.2285 69.2935 61.9916 69.2935C80.7546 69.2935 96.924 82.5864 104.286 101.734C108.999 113.991 97.8815 125 84.7497 125H39.2334C26.1016 125 14.9839 113.991 19.6967 101.734Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62 58.0132C75.5457 58.0132 86.9 45.7141 86.9 30.0566C86.9 14.3991 75.5457 2.1 62 2.1C48.4543 2.1 37.1 14.3991 37.1 30.0566C37.1 45.7141 48.4543 58.0132 62 58.0132ZM62 60.1132C76.9117 60.1132 89 46.6564 89 30.0566C89 13.4568 76.9117 0 62 0C47.0883 0 35 13.4568 35 30.0566C35 46.6564 47.0883 60.1132 62 60.1132Z"
        fill="white"
      />
      <line
        x1="16.5"
        y1="45.5"
        x2="16.5"
        y2="72.5"
        stroke="white"
        strokeWidth="5"
        strokeLinecap="round"
      />
      <line
        x1="29.5"
        y1="59.5"
        x2="2.5"
        y2="59.5"
        stroke="white"
        strokeWidth="5"
        strokeLinecap="round"
      />
    </svg>
  );
}
